<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <div>
          <v-icon class="mr-2" color="primary">mdi-comment-text</v-icon>
          {{ modo === 'visualizar' ? 'Visualizar Comentários' : 'Editar Comentários' }}
        </div>
        <v-btn icon @click="fecharModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <!-- Layout para dois comentários lado a lado -->
        <div v-if="mostrarDoisComentarios" class="d-flex">
          <!-- Modal da Esquerda - CRONOGRAMA -->
          <div class="flex-1 mr-2">
            <v-card outlined class="pa-3">
              <v-card-title class="text-h6 pa-2">
                <v-icon class="mr-2" color="primary">mdi-clock</v-icon>
                CRONOGRAMA
              </v-card-title>
              <div class="mb-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Host: {{ atualizacao.hostName }} (ID: {{ atualizacao.id }})
                </div>
                <div class="text-body-2 text--secondary">
                  Sistema: {{ atualizacao.sistema }} | Método: CRONOGRAMA
                </div>
              </div>
              
              <v-divider class="mb-3"></v-divider>
              
              <!-- Verificações do CRONOGRAMA -->
              <div class="mb-3">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  Verificações de Ambiente
                </div>
                <div v-if="modo === 'visualizar'">
                  <v-list dense>
                    <v-list-item v-for="(verificacao, key) in verificacoesCronograma" :key="key">
                      <v-list-item-icon>
                        <v-icon :color="verificacao ? 'success' : 'error'">
                          {{ verificacao ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ getVerificacaoLabel(key) }}: {{ formatarVerificacao(verificacao) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
              
              <v-divider class="mb-3"></v-divider>
              
              <!-- Comentário do CRONOGRAMA -->
              <div class="mb-3">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  Comentário Adicional
                </div>
                <div class="pa-3 bg-grey-lighten-4 rounded">
                  <div class="text-caption">
                    {{ formatarComentario(comentarioCronograma) }}
                  </div>
                </div>
              </div>
              
              <!-- Informações de auditoria do CRONOGRAMA -->
              <div v-if="comentarioExistente" class="mb-3">
                <v-divider class="mb-2"></v-divider>
                <div class="text-caption text--secondary">
                  <div>Última atualização: {{ formatarData(comentarioExistente.ultimaAtualizacao) }}</div>
                  <div v-if="comentarioExistente.usuarioAtualizacao">
                    Por: {{ comentarioExistente.usuarioAtualizacao }}
                  </div>
                </div>
              </div>
            </v-card>
          </div>
          
          <!-- Modal da Direita - CRONOGRAMA_RETRY -->
          <div class="flex-1 ml-2">
            <v-card outlined class="pa-3">
              <v-card-title class="text-h6 pa-2">
                <v-icon class="mr-2" color="warning">mdi-refresh</v-icon>
                CRONOGRAMA_RETRY
              </v-card-title>
              <div class="mb-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Host: {{ atualizacao.hostName }} (ID: {{ atualizacaoRetry ? atualizacaoRetry.id : 'N/A' }})
                </div>
                <div class="text-body-2 text--secondary">
                  Sistema: {{ atualizacao.sistema }} | Método: CRONOGRAMA_RETRY
                </div>
              </div>
              
              <v-divider class="mb-3"></v-divider>
              
              <!-- Verificações do CRONOGRAMA_RETRY -->
              <div class="mb-3">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  Verificações de Ambiente
                </div>
                <div v-if="modo === 'visualizar'">
                  <v-list dense>
                    <v-list-item v-for="(verificacao, key) in verificacoesRetry" :key="key">
                      <v-list-item-icon>
                        <v-icon :color="verificacao ? 'success' : 'error'">
                          {{ verificacao ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ getVerificacaoLabel(key) }}: {{ formatarVerificacao(verificacao) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
              
              <v-divider class="mb-3"></v-divider>
              
              <!-- Comentário do CRONOGRAMA_RETRY -->
              <div class="mb-3">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  Comentário Adicional
                </div>
                <div class="pa-3 bg-grey-lighten-4 rounded">
                  <div class="text-caption">
                    {{ formatarComentario(comentarioRetry) }}
                  </div>
                </div>
              </div>
              
              <!-- Informações de auditoria do CRONOGRAMA_RETRY -->
              <div v-if="comentarioExistenteRetry" class="mb-3">
                <v-divider class="mb-2"></v-divider>
                <div class="text-caption text--secondary">
                  <div>Última atualização: {{ formatarData(comentarioExistenteRetry.ultimaAtualizacao) }}</div>
                  <div v-if="comentarioExistenteRetry.usuarioAtualizacao">
                    Por: {{ comentarioExistenteRetry.usuarioAtualizacao }}
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
        
        <!-- Layout original para um único comentário -->
        <div v-else>
          <div class="mb-4">
            <div class="text-subtitle-1 font-weight-medium mb-2">
              Host: {{ atualizacao.hostName }} (ID: {{ atualizacao.id }})
            </div>
            <div class="text-body-2 text--secondary">
              Sistema: {{ atualizacao.sistema }} | Método: {{ atualizacao.metodo }}
            </div>
          </div>
          
          <v-divider class="mb-4"></v-divider>
          
          <!-- Campos de verificação -->
          <div class="mb-4">
            <div class="d-flex align-center justify-space-between mb-3">
              <div class="text-subtitle-2 font-weight-medium">
                Verificações de Ambiente
              </div>
              <v-btn
                v-if="modo === 'editar'"
                small
                outlined
                color="primary"
                @click="marcarTodos"
                class="ml-2"
              >
                <v-icon small left>mdi-check-all</v-icon>
                Marcar Todos
              </v-btn>
            </div>
            
            <!-- Modo visualização: exibir como lista formatada -->
            <div v-if="modo === 'visualizar'">
              <v-list dense>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.usuarioCriado ? 'success' : 'error'">
                      {{ verificacoes.usuarioCriado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Usuário está criado: {{ formatarVerificacao(verificacoes.usuarioCriado) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.usuarioGruposCorretos ? 'success' : 'error'">
                      {{ verificacoes.usuarioGruposCorretos ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Usuário está nos grupos corretos: {{ formatarVerificacao(verificacoes.usuarioGruposCorretos) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.usuarioAcessaServidor ? 'success' : 'error'">
                      {{ verificacoes.usuarioAcessaServidor ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Usuário está conseguindo acessar o servidor: {{ formatarVerificacao(verificacoes.usuarioAcessaServidor) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.scriptMacroMasterExiste ? 'success' : 'error'">
                      {{ verificacoes.scriptMacroMasterExiste ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Script MacroMaster.bat existe: {{ formatarVerificacao(verificacoes.scriptMacroMasterExiste) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.scriptPermissoesCorretas ? 'success' : 'error'">
                      {{ verificacoes.scriptPermissoesCorretas ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Permissões corretas: {{ formatarVerificacao(verificacoes.scriptPermissoesCorretas) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.pastaMacroAtualizacaoExiste ? 'success' : 'error'">
                      {{ verificacoes.pastaMacroAtualizacaoExiste ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Pasta Macro-Atualizacao existe: {{ formatarVerificacao(verificacoes.pastaMacroAtualizacaoExiste) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.logMacroMasterExiste ? 'success' : 'error'">
                      {{ verificacoes.logMacroMasterExiste ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Log MacroMaster.bat existe: {{ formatarVerificacao(verificacoes.logMacroMasterExiste) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="verificacoes.logAtualizacaoAutomaticaExiste ? 'success' : 'error'">
                      {{ verificacoes.logAtualizacaoAutomaticaExiste ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Log AtualizacaoAutomatica.exe existe: {{ formatarVerificacao(verificacoes.logAtualizacaoAutomaticaExiste) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            
            <!-- Modo edição: exibir como switches -->
            <v-row v-else>
              <v-col cols="12" md="6">
                <v-switch
                  v-model="verificacoes.usuarioCriado"
                  label="Usuário está criado"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.usuarioGruposCorretos"
                  label="Usuário está nos grupos corretos"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.usuarioAcessaServidor"
                  label="Usuário está conseguindo acessar o servidor"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.scriptMacroMasterExiste"
                  label="Existe o Script C:\Scripts\AtualizacaoAutomatica\MacroMaster.bat"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-switch
                  v-model="verificacoes.scriptPermissoesCorretas"
                  label="Script MacroMaster.bat e Diretório C:\Scripts\AtualizacaoAutomatica contém as permissões necessárias"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.pastaMacroAtualizacaoExiste"
                  label="Existe a pasta C:\Macro-Atualizacao"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.logMacroMasterExiste"
                  label="Existe log de execução do MacroMaster.bat em C:\Scripts\AtualizacaoAutomatica"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
                
                <v-switch
                  v-model="verificacoes.logAtualizacaoAutomaticaExiste"
                  label="Existe log de execução da AtualizacaoAutomatica.exe em C:\Macro-Atualizacao"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-switch>
              </v-col>
            </v-row>
          </div>
          
          <v-divider class="mb-4"></v-divider>
          
          <!-- Campo de comentário livre -->
          <div class="mb-4">
            <div class="text-subtitle-2 font-weight-medium mb-2">
              Comentário Adicional
            </div>
            
            <!-- Modo visualização: exibir como texto formatado -->
            <div v-if="modo === 'visualizar'" class="pa-3 bg-grey-lighten-4 rounded">
              <div class="text-caption">
                {{ formatarComentario(comentarioTexto) }}
              </div>
            </div>
            
            <!-- Modo edição: exibir como textarea -->
            <v-textarea
              v-else
              v-model="comentarioTexto"
              label="Digite detalhes, observações ou questões sobre esta atualização"
              outlined
              rows="4"
              auto-grow
              placeholder="Ex: Usuário reportou erro de permissão ao executar script. Verificar configurações de segurança..."
            ></v-textarea>
          </div>
          
          <!-- Informações de auditoria -->
          <div v-if="comentarioExistente" class="mb-4">
            <v-divider class="mb-3"></v-divider>
            <div class="text-caption text--secondary">
              <div>Última atualização: {{ formatarData(comentarioExistente.ultimaAtualizacao) }}</div>
              <div v-if="comentarioExistente.usuarioAtualizacao">
                Por: {{ comentarioExistente.usuarioAtualizacao }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          v-if="modo === 'editar'"
          text
          @click="fecharModal"
          class="mr-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-if="modo === 'visualizar'"
          color="primary"
          @click="fecharModal"
        >
          Fechar
        </v-btn>
        <v-btn
          v-if="modo === 'editar'"
          color="primary"
          @click="salvarComentario"
          :loading="salvando"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dashboardService from '@/services/dashboardService'

export default {
  name: 'ComentarioModal',
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    atualizacao: {
      type: Object,
      required: true
    },
    modo: {
      type: String,
      default: 'visualizar', // 'visualizar' ou 'editar'
      validator: value => ['visualizar', 'editar'].includes(value)
    },
    // Nova prop para receber dados do retry se disponível
    atualizacaoRetry: {
      type: Object,
      default: null
    }
  },
  
  data() {
    return {
      salvando: false,
      verificacoes: {
        usuarioCriado: false,
        usuarioGruposCorretos: false,
        scriptMacroMasterExiste: false,
        scriptPermissoesCorretas: false,
        pastaMacroAtualizacaoExiste: false,
        logMacroMasterExiste: false,
        logAtualizacaoAutomaticaExiste: false,
        usuarioAcessaServidor: false
      },
      comentarioTexto: '',
      comentarioExistente: null,
      // Novas variáveis para o comentário do retry
      comentarioExistenteRetry: null
    }
  },
  
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    mostrarDoisComentarios() {
      // Mostrar dois comentários apenas no modo visualização E se temos dados do retry
      const resultado = this.modo === 'visualizar' && this.atualizacaoRetry && this.atualizacaoRetry.id;
      
      console.log('[DEBUG] mostrarDoisComentarios - Valores:', {
        modo: this.modo,
        atualizacaoRetry: this.atualizacaoRetry,
        atualizacaoRetryId: this.atualizacaoRetry?.id,
        resultado: resultado,
        // Verificar se é um CRONOGRAMA para mostrar o layout duplo
        isCronograma: this.atualizacao?.metodo === 'CRONOGRAMA',
        // Verificar se temos dados válidos do retry
        hasValidRetry: this.atualizacaoRetry && this.atualizacaoRetry.id && this.atualizacaoRetry.metodo === 'CRONOGRAMA_RETRY'
      });
      
      // Condição mais específica: deve ser CRONOGRAMA + CRONOGRAMA_RETRY
      const resultadoFinal = this.modo === 'visualizar' && 
                           this.atualizacao?.metodo === 'CRONOGRAMA' && 
                           this.atualizacaoRetry && 
                           this.atualizacaoRetry.id && 
                           this.atualizacaoRetry.metodo === 'CRONOGRAMA_RETRY';
      
      console.log('[DEBUG] mostrarDoisComentarios - Resultado final:', resultadoFinal);
      
      return resultadoFinal;
    },
    verificacoesCronograma() {
      return this.verificacoes;
    },
    comentarioCronograma() {
      return this.comentarioTexto;
    },
    verificacoesRetry() {
      if (!this.atualizacaoRetry) return {};
      
      // Se temos comentário existente do retry, usar ele
      if (this.comentarioExistenteRetry && this.comentarioExistenteRetry.verificacoes) {
        return this.comentarioExistenteRetry.verificacoes;
      }
      
      // Caso contrário, retornar verificações vazias
      return {
        usuarioCriado: undefined,
        usuarioGruposCorretos: undefined,
        scriptMacroMasterExiste: undefined,
        scriptPermissoesCorretas: undefined,
        pastaMacroAtualizacaoExiste: undefined,
        logMacroMasterExiste: undefined,
        logAtualizacaoAutomaticaExiste: undefined,
        usuarioAcessaServidor: undefined
      };
    },
    comentarioRetry() {
      if (!this.atualizacaoRetry) return '';
      
      // Se temos comentário existente do retry, usar ele
      if (this.comentarioExistenteRetry && this.comentarioExistenteRetry.comentario) {
        return this.comentarioExistenteRetry.comentario;
      }
      
      return 'Nada Informado';
    }
  },
         
  mounted() {
    console.log('[DEBUG] Modal montado - Modo:', this.modo);
    console.log('[DEBUG] Modal montado - atualizacao:', this.atualizacao);
    console.log('[DEBUG] Modal montado - atualizacaoRetry:', this.atualizacaoRetry);
  },
  
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.carregarComentarioExistente()
      } else {
        // Limpar formulário apenas quando fechar o modal no modo edição
        if (this.modo === 'editar') {
          this.limparFormulario()
        }
      }
    },
    // Observar mudanças na prop atualizacaoRetry
    atualizacaoRetry: {
      handler(newVal, oldVal) {
        console.log('[DEBUG] atualizacaoRetry mudou:', { oldVal, newVal });
        if (newVal && this.dialog) {
          console.log('[DEBUG] Chamando carregarComentarioRetry...');
          this.carregarComentarioRetry();
        }
      },
      immediate: true
    }
  },

  methods: {
    marcarTodos() {
      // Marcar todas as verificações como true
      this.verificacoes = {
        usuarioCriado: true,
        usuarioGruposCorretos: true,
        scriptMacroMasterExiste: true,
        scriptPermissoesCorretas: true,
        pastaMacroAtualizacaoExiste: true,
        logMacroMasterExiste: true,
        logAtualizacaoAutomaticaExiste: true,
        usuarioAcessaServidor: true
      }
    },
    
    async carregarComentarioExistente() {
      try {
        console.log('[DEBUG] Carregando comentário para ID:', this.atualizacao.id);
        
        // Buscar comentário existente da API
        const response = await dashboardService.getComentario(this.atualizacao.id)
        
        console.log('[DEBUG] Resposta do getComentario:', response);
        
        // Verificar se a resposta tem a estrutura esperada
        if (response && response.controle && response.controle.comentario) {
          console.log('[DEBUG] Campo comentario encontrado:', response.controle.comentario);
          
          // Se o comentario é uma string JSON, fazer parse
          if (typeof response.controle.comentario === 'string') {
            try {
              const comentarioParseado = JSON.parse(response.controle.comentario);
              console.log('[DEBUG] Comentário parseado:', comentarioParseado);
              
              this.comentarioExistente = comentarioParseado
              
              // Preencher verificações se existirem
              if (comentarioParseado.verificacoes) {
                this.verificacoes = { ...this.verificacoes, ...comentarioParseado.verificacoes }
                console.log('[DEBUG] Verificações preenchidas:', this.verificacoes);
              }
              
              // Preencher comentário se existir
              if (comentarioParseado.comentario) {
                this.comentarioTexto = comentarioParseado.comentario
                console.log('[DEBUG] Comentário texto preenchido:', this.comentarioTexto);
              }
              
              console.log('[DEBUG] Comentário carregado com sucesso:', {
                verificacoes: this.verificacoes,
                comentario: this.comentarioTexto,
                modo: this.modo,
                comentarioExistente: this.comentarioExistente
              })
            } catch (parseError) {
              console.error('[DEBUG] Erro ao fazer parse do comentário:', parseError);
              this.limparFormulario()
            }
          } else {
            console.log('[DEBUG] Campo comentario não é string JSON:', typeof response.controle.comentario);
            this.limparFormulario()
          }
        } else {
          console.log('[DEBUG] Nenhum comentário encontrado ou erro na resposta');
          // Limpar dados se não houver comentário
          this.comentarioExistente = null
          this.limparFormulario()
        }
        
        // Se temos dados do retry, carregar também
        if (this.atualizacaoRetry && this.atualizacaoRetry.id) {
          await this.carregarComentarioRetry();
        }
      } catch (error) {
        console.error('Erro ao carregar comentário:', error)
        this.limparFormulario()
      }
    },
    
    async carregarComentarioRetry() {
      try {
        console.log('[DEBUG] Carregando comentário do retry para ID:', this.atualizacaoRetry.id);
        
        // Buscar comentário existente do retry da API
        const response = await dashboardService.getComentario(this.atualizacaoRetry.id)
        
        console.log('[DEBUG] Resposta do getComentario do retry:', response);
        
        // Verificar se a resposta tem a estrutura esperada
        if (response && response.controle && response.controle.comentario) {
          console.log('[DEBUG] Campo comentario do retry encontrado:', response.controle.comentario);
          
          // Se o comentario é uma string JSON, fazer parse
          if (typeof response.controle.comentario === 'string') {
            try {
              const comentarioParseado = JSON.parse(response.controle.comentario);
              console.log('[DEBUG] Comentário do retry parseado:', comentarioParseado);
              
              this.comentarioExistenteRetry = comentarioParseado
              
              console.log('[DEBUG] Comentário do retry carregado com sucesso:', {
                comentarioExistenteRetry: this.comentarioExistenteRetry
              })
            } catch (parseError) {
              console.error('[DEBUG] Erro ao fazer parse do comentário do retry:', parseError);
              this.comentarioExistenteRetry = null
            }
          } else {
            console.log('[DEBUG] Campo comentario do retry não é string JSON:', typeof response.controle.comentario);
            this.comentarioExistenteRetry = null
          }
        } else {
          console.log('[DEBUG] Nenhum comentário do retry encontrado ou erro na resposta');
          this.comentarioExistenteRetry = null
        }
      } catch (error) {
        console.error('Erro ao carregar comentário do retry:', error)
        this.comentarioExistenteRetry = null
      }
    },
    
    limparFormulario() {
      // Só limpar se não estiver no modo visualização
      if (this.modo !== 'visualizar') {
        this.verificacoes = {
          usuarioCriado: false,
          usuarioGruposCorretos: false,
          scriptMacroMasterExiste: false,
          scriptPermissoesCorretas: false,
          pastaMacroAtualizacaoExiste: false,
          logMacroMasterExiste: false,
          logAtualizacaoAutomaticaExiste: false,
          usuarioAcessaServidor: false
        }
        this.comentarioTexto = ''
      } else {
        // No modo visualização, se não há comentário existente, deixar as verificações como undefined
        // para que mostrem "Não Informado"
        if (!this.comentarioExistente) {
          this.verificacoes = {
            usuarioCriado: undefined,
            usuarioGruposCorretos: undefined,
            scriptMacroMasterExiste: undefined,
            scriptPermissoesCorretas: undefined,
            pastaMacroAtualizacaoExiste: undefined,
            logMacroMasterExiste: undefined,
            logAtualizacaoAutomaticaExiste: undefined,
            usuarioAcessaServidor: undefined
          }
          this.comentarioTexto = ''
        }
      }
      
      // Limpar dados do retry
      this.comentarioExistenteRetry = null
    },
    
    async salvarComentario() {
      this.salvando = true
      
      try {
        // Sempre sobrescrever completamente o comentário anterior
        const dadosComentario = {
          id: this.atualizacao.id,
          verificacoes: { ...this.verificacoes }, // Clonar para evitar referências
          comentario: this.comentarioTexto,
          ultimaAtualizacao: new Date().toISOString()
          // O nome do usuário será preenchido pelo backend
        }
        
        console.log('[DEBUG] Salvando comentário (sobrescrevendo):', dadosComentario)
        
        const response = await dashboardService.salvarComentario(dadosComentario)
        
        if (response.success) {
          this.$emit('comentario-salvo', dadosComentario)
          this.mostrarNotificacao('Comentário salvo com sucesso!', 'success')
          this.fecharModal()
        } else {
          throw new Error(response.message || 'Erro ao salvar comentário')
        }
      } catch (error) {
        console.error('Erro ao salvar comentário:', error)
        this.mostrarNotificacao(
          error.message || 'Erro ao salvar comentário', 
          'error'
        )
      } finally {
        this.salvando = false
      }
    },
    
    fecharModal() {
      this.dialog = false
    },
    
    mostrarNotificacao(texto, cor = 'info') {
      this.$emit('show-snackbar', texto, cor)
    },
    
    formatarData(dataString) {
      if (!dataString) return ''
      
      try {
        const data = new Date(dataString)
        return data.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return dataString
      }
    },

    formatarVerificacao(valor) {
      if (valor === true) {
        return '✅ Sim'
      } else if (valor === false) {
        // Se não há comentário existente, mostrar "Não Informado" em vez de "Não"
        if (!this.comentarioExistente) {
          return '❓ Não Informado'
        }
        return '❌ Não'
      } else {
        return '❓ Não Informado'
      }
    },

    formatarComentario(comentario) {
      if (!comentario) return 'Nada Informado'
      return comentario
    },

    obterNomeUsuario() {
      // Tentar obter o nome do usuário do localStorage ou do contexto da aplicação
      try {
        // Verificar se há informações do usuário no localStorage
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          const user = JSON.parse(userInfo)
          if (user.name) {
            return user.name
          }
          if (user.username) {
            return user.username
          }
        }
        
        // Verificar se há informações do usuário no contexto da aplicação
        if (this.$store && this.$store.state.user) {
          const user = this.$store.state.user
          if (user.name) {
            return user.name
          }
          if (user.username) {
            return user.username
          }
        }
        
        // Fallback: usar o nome do usuário do sistema ou um valor padrão
        return 'Usuário do Sistema'
      } catch (error) {
        console.warn('Erro ao obter nome do usuário:', error)
        return 'Usuário do Sistema'
      }
    },
    getVerificacaoLabel(key) {
      switch (key) {
        case 'usuarioCriado': return 'Usuário está criado';
        case 'usuarioGruposCorretos': return 'Usuário está nos grupos corretos';
        case 'usuarioAcessaServidor': return 'Usuário está conseguindo acessar o servidor';
        case 'scriptMacroMasterExiste': return 'Script MacroMaster.bat existe';
        case 'scriptPermissoesCorretas': return 'Permissões corretas';
        case 'pastaMacroAtualizacaoExiste': return 'Pasta Macro-Atualizacao existe';
        case 'logMacroMasterExiste': return 'Log MacroMaster.bat existe';
        case 'logAtualizacaoAutomaticaExiste': return 'Log AtualizacaoAutomatica.exe existe';
        default: return key;
      }
    }
  }
}
</script>

<style scoped>
.v-switch {
  margin-bottom: 8px;
}

.v-switch .v-label {
  font-size: 0.875rem;
}

.flex-1 {
  flex: 1 1 0%;
  min-width: 0;
}

.d-flex {
  display: flex;
  gap: 8px;
}

.mr-2 {
  margin-right: 8px;
}

.ml-2 {
  margin-left: 8px;
}

/* Garantir que os dois painéis tenham tamanhos iguais */
.d-flex > div {
  flex: 1;
  min-width: 0;
}
</style>
